import React from 'react';
import ActivitySortControls from '@/components/activity/ActivitySortControls';
import ListResultsBar from '@/components/shared/ListResultsBar';
import type { ActivitySortOrder } from '@/types/activity';

interface ActivityResultsBarProps {
  totalResults: number;
  sortOrder: ActivitySortOrder;
  onSortOrderChange: (order: ActivitySortOrder) => void;
}

const ActivityResultsBar: React.FC<ActivityResultsBarProps> = ({ totalResults, sortOrder, onSortOrderChange }) => {
  const countLabel = `${totalResults} ${totalResults === 1 ? 'event' : 'events'}`;

  return (
    <ListResultsBar
      countLabel={countLabel}
      trailing={<ActivitySortControls sortOrder={sortOrder} onSortOrderChange={onSortOrderChange} />}
    />
  );
};

export default ActivityResultsBar;
